var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.95 25.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#ffab02;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 25.95,
    height: 25.95,
    rx: 5.38,
    ry: 5.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "supportalt",
    className: "cls-1",
    d: "m12.97,20.41c-2.66,0-5.12-1.41-6.44-3.71-.66-1.13-1-2.42-1-3.73,0-2.66,1.41-5.12,3.71-6.44,1.13-.66,2.42-1,3.73-1,2.66,0,5.12,1.41,6.44,3.71.66,1.13,1,2.42,1,3.73,0,2.66-1.41,5.12-3.71,6.44-1.13.66-2.42,1-3.73,1Zm-1.86-1.21c1.21.37,2.51.37,3.72,0v-3.02c-.56.34-1.2.51-1.85.51-.66,0-1.3-.17-1.87-.51v3.02h0Zm-1.35-8.09h-3.02c-.37,1.21-.37,2.51,0,3.72h3.02c-.68-1.15-.68-2.57,0-3.72h0Zm5.07-4.37c-1.21-.37-2.51-.37-3.72,0v3.02c1.15-.68,2.57-.68,3.72,0v-3.02Zm-1.86,3.44c-1.53,0-2.78,1.23-2.79,2.77,0,0,0,.01,0,.02,0,1.53,1.23,2.78,2.77,2.79,0,0,.01,0,.02,0,1.53,0,2.78-1.23,2.79-2.77,0,0,0-.01,0-.02,0-1.53-1.23-2.78-2.77-2.79,0,0-.01,0-.02,0Zm3.21.93c.68,1.15.68,2.57,0,3.72h3.02c.37-1.21.37-2.51,0-3.72h-3.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact2);
export default __webpack_public_path__ + "static/media/contact2.05fe0dd1618e9989e4b4376f95c0732f.svg";
export { ForwardRef as ReactComponent };